// src/components/MemberTable/ExportModal.jsx

import React from 'react';
import PropTypes from 'prop-types';
import ActionButton from '../Common/ActionButton';
import CustomModal from '../Common/CustomModal';
import { useTranslation } from 'react-i18next';
import './ExportModal.css'; // Import the specific CSS for ExportModal

const ExportModal = ({ show, onClose, onExport }) => {
  const { t } = useTranslation();

  const handleExport = (format) => {
    onExport(format);
    onClose();
  };

  return (
    <CustomModal
      show={show}
      onClose={onClose}
      title={t('memberTable.selectExportFormat')}
    >
      <div className="export-modal-content">
        <ActionButton
          onClick={() => handleExport('csv')}
          text={t('memberTable.exportCSV')}
          icon={'faDownload'}
          isMobile={false}
          colorType="primary"
        />
        <ActionButton
          onClick={() => handleExport('json')}
          text={t('memberTable.exportJSON')}
          icon={'faDownload'}
          isMobile={false}
          colorType="primary"
        />
      </div>
    </CustomModal>
  );
};

ExportModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onExport: PropTypes.func.isRequired,
};

export default ExportModal;
